export const mapHeadTitles = {
  checkbox: '',
  agreementAttention: '',
  id: 'ID Абонента',
  fullName: 'ФИО',
  fullAddress: 'Адрес',
  phone: 'Телефон',
  categories: 'Льготная категория',
}

export const sortedKeys = ['id', 'created', 'name', 'locality']

export const widthMap: Record<string, string> = {
  checkbox: '2%',
  agreementAttention: '2%',
  categories: '15%',
  id: '7%',
  fullName: '15%',
  fullAddress: '20%',
  phone: '10%',
}

export const emptyTableHeadKeys = ['checkbox']
